var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrialRequestInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,2 C0,0.89543 0.89543,0 2,0 L20,0 C21.1046,0 22,0.89543 22,2 L22,15.4167 C22,16.5212 21.1046,17.4167 20,17.4167 L2,17.4167 C0.89543,17.4167 0,16.5212 0,15.4167 L0,2 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2 C0,0.89543 0.89543,0 2,0 L20,0 C21.1046,0 22,0.89543 22,2 L22,15.4167 C22,16.5212 21.1046,17.4167 20,17.4167 L2,17.4167 C0.89543,17.4167 0,16.5212 0,15.4167 L0,2 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2 C0,0.89543 0.89543,0 2,0 L20,0 C21.1046,0 22,0.89543 22,2 L22,15.4167 C22,16.5212 21.1046,17.4167 20,17.4167 L2,17.4167 C0.89543,17.4167 0,16.5212 0,15.4167 L0,2 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trial-Request_inactive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875,15.125 L0,15.125 L0,20.7929 C0,21.2383 0.53857,21.4614 0.85355,21.1464 L6.875,15.125 Z",
    id: "Path",
    fill: "#D2E1FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D2E1FA",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: 0,
    y: 0,
    width: 22,
    height: 17.4167,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B4CEFA",
    points: "0 22 22 0 22 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8271,3.07592 C12.7605,2.37866 12.1731,1.83334 11.4584,1.83334 C10.699,1.83334 10.0834,2.44895 10.0834,3.20834 L10.0834,9.625 L10.0897,9.7574 C10.1563,10.4547 10.7437,11 11.4584,11 C12.2178,11 12.8334,10.3844 12.8334,9.625 L12.8334,3.20834 L12.8271,3.07592 Z M11.4584,15.5833 C12.2178,15.5833 12.8334,14.9677 12.8334,14.2083 C12.8334,13.4489 12.2178,12.8333 11.4584,12.8333 C10.699,12.8333 10.0834,13.4489 10.0834,14.2083 C10.0834,14.9677 10.699,15.5833 11.4584,15.5833 Z",
    id: "Shape",
    fill: "#3B7FF5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrialRequestInactive);
export default __webpack_public_path__ + "static/media/trial-request-inactive.c475e6c43450f0bb94e552b6c1e00dfa.svg";
export { ForwardRef as ReactComponent };